import {Component, EventEmitter, HostListener, Input, Output, ViewEncapsulation} from '@angular/core';
import {keyboardKeys} from '../../constants/keyboard-keys.constants';

@Component({
  selector: 'si-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SwitchComponent {
  @Input() text: string;
  @Input() styleClass: string;
  @Input() id: string;
  @Input() name: string;
  @Input() infoTooltipText: string;
  @Input() showAlert: boolean;
  @Input() alertTooltipText: string;
  @Input() model: boolean;
  @Output() modelChange = new EventEmitter<boolean>();
  @Input() disabled: boolean;
  private _checked: boolean;

  constructor() {
  }

  get checked(): boolean {
    return this._checked;
  }

  @Input()
  set checked(val) {
    if (this.model != null) {
      return;
    }

    this.model = !!val;
    this.onChangeModel(this.model);
  }

  onChangeModel(model): void {
    setTimeout(() => {
      this.modelChange.emit(model);
    });
  }

  @HostListener('keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === keyboardKeys.ENTER) {
      this.model = !this.model;
      this.onChangeModel(this.model);
    }
  }
}